import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { useI18n } from "../i18n/I18nContext";
import { api } from "../lib/api";
import { SITE_INFO, CLIENT_LOGOS } from "../config/site";

export const Footer = () => {
  const { t, prefix, lp } = useI18n();
  const [s, setS] = useState({ company_name: "TP Agency", email: SITE_INFO.email, website: "tpagency.co", location: "Netherlands", phone: SITE_INFO.phone });
  useEffect(() => { api.get("/site-settings").then(r => setS(r.data)).catch(() => {}); }, []);
  const year = new Date().getFullYear();
  const companyLinks = [
    { to: prefix || "/", label: t.nav.home, testid: "footer-link-home" },
    { to: lp("/how-it-works"), label: t.nav.how, testid: "footer-link-how" },
    { to: lp("/pricing"), label: t.nav.pricing, testid: "footer-link-pricing" },
    { to: lp("/industries"), label: t.nav.industries, testid: "footer-link-industries" },
    { to: lp("/about"), label: t.nav.about, testid: "footer-link-about" },
    { to: lp("/contact"), label: t.nav.contact, testid: "footer-link-contact" },
  ];
  return (
    <footer className="relative mt-20 border-t border-white/10 bg-[#040813]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid sm:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="sm:col-span-2">
          <Logo />
          <p className="text-slate-400 mt-4 max-w-sm leading-relaxed text-sm">{t.footer.tagline}</p>
          {CLIENT_LOGOS.length > 0 && (
            <div className="mt-8" data-testid="footer-client-logos">
              <div className="eyebrow mb-3">{t.footer.trustedBy}</div>
              <div className="flex flex-wrap items-center gap-3">
                {CLIENT_LOGOS.map((l) => (
                  <div key={l.name} className="bg-white/5 border border-white/10 rounded-lg px-4 py-2.5">
                    <img src={l.src} alt={l.name} className="h-10 w-auto object-contain" loading="lazy" />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div>
          <div className="eyebrow mb-4">{t.footer.services}</div>
          <div className="space-y-2.5 text-sm">
            {t.navMenus.services.map((it) => (
              <Link key={it.to} to={it.to} className="block text-slate-300 hover:text-white" data-testid={`footer-service-${it.to.split("#")[1]}`}>{it.label}</Link>
            ))}
          </div>
        </div>
        <div>
          <div className="eyebrow mb-4">{t.footer.company}</div>
          <div className="space-y-2.5 text-sm">
            {companyLinks.map((l) => (
              <Link key={l.to} to={l.to} className="block text-slate-300 hover:text-white" data-testid={l.testid}>{l.label}</Link>
            ))}
          </div>
        </div>
        <div>
          <div className="eyebrow mb-4">{t.footer.contactHeading}</div>
          <div className="space-y-2 text-sm text-slate-300" data-testid="footer-contact-info">
            <div>{s.company_name}</div>
            <a href={`mailto:${s.email}`} className="block hover:text-cyan-300 break-all" data-testid="footer-email">{s.email}</a>
            {s.phone && (
              <a href={`tel:${String(s.phone).replace(/[^\d+]/g, "")}`} className="block hover:text-cyan-300 font-mono" data-testid="footer-phone">{s.phone}</a>
            )}
            <div className="text-slate-400 font-mono" data-testid="footer-kvk">KVK: {SITE_INFO.kvk}</div>
            <div className="text-slate-400">{s.website}</div>
            <div className="text-slate-400">{s.location}</div>
          </div>
          <p className="mt-4 pt-3 border-t border-white/5 text-xs text-slate-500 leading-relaxed" data-testid="footer-caller-id-notice">
            <span className="text-slate-400">{t.contact.callerIdTitle}</span>{" "}
            {t.contact.callerIdNote}{" "}
            <span className="font-mono text-slate-300" data-testid="footer-caller-id-number">{SITE_INFO.outboundCallerId}</span>.
          </p>
        </div>
      </div>
      <div className="border-t border-white/5 py-5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div data-testid="footer-copyright">© {year} {s.company_name}. {t.footer.rights}</div>
          <div className="flex items-center gap-5">
            <Link to={lp("/privacy")} className="hover:text-white transition-colors" data-testid="footer-link-privacy">{t.footer.privacy}</Link>
            <Link to={lp("/terms")} className="hover:text-white transition-colors" data-testid="footer-link-terms">{t.footer.terms}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
